<template>
    <h5 v-if="rolPuedeEditar">Modificar Rol</h5>
    <h5 v-if="!rolPuedeEditar">Consultar Rol</h5>
    <Form role="form" class="text-start" @submit="handleEditaRol">

        <soft-field
            id="nombre"
            v-model="rolEditNombre"
            type="text"
            label="Nombre"
            placeholder="Indique su nombre"
            name="nombre"
            class="mb-4"
            :readonly="!rolPuedeEditar"/>

        <label for="none">Permisos</label>
        <div class="row">
            <div class="col-sm-6" v-for="permiso in permisos2" :key="permiso.id">
            <soft-switch :id="'permiso' + permiso.id" :name="'permiso' + permiso.id" @change="cambiarDinamico('permiso' + permiso.id)" :checked="validaMarcado(permiso.id)" :disabled="!rolPuedeEditar" style="display:inline-block;"/>
            <label :for="'permiso' + permiso.id">{{permiso.descripcion}}</label>
            </div>
        </div>

        <div class="text-center mt-5">
            <soft-button
                class="my-2 mb-2 text-sm"
                color="analiza-azul"
                full-width
                :is-disabled="!rolPuedeEditar"
                >
                <span
                    v-if="loading"
                    class="spinner-border spinner-border-sm"
                ></span>
                <span v-else>Confirmar</span>
            </soft-button>
        </div>
    </Form>
  </template>
  
  <script>
  import SoftField from "@/components/SoftField.vue";
  import SoftButton from "@/components/SoftButton.vue";
  import SoftSwitch from "@/components/SoftSwitch.vue";
  import showSwal from "/src/mixins/showSwal.js";
  import { Form } from "vee-validate";

  export default {
    name: "EditaRolForm",
    components: {
        SoftField,
        SoftButton,
        SoftSwitch,
        Form,
    },
    props: {
        rolId: Number,
        rolNombre: String,
        rolPermisos: Array,
        puedeEditar: Boolean
    },
    data() {
        const permisos2 = {};

        const permisos = {}; 

        return {
            loading: false,
            permisos,
            permisos2,
            rolEditId: this.rolId,
            rolEditNombre: this.rolNombre,
            rolEditPermisos: this.rolPermisos,
            rolPuedeEditar: this.puedeEditar,
        };
    },
    emits: ['cerrar-modal'],
    methods: {
        async handleEditaRol() {
            // Aquí puedes realizar acciones cuando se envía el formulario
            this.loading = true;

                try {             
                    this.loading = false;
                    this.permisos['id'] = this.rolId; 
                    this.permisos['nombre'] = this.rolEditNombre; 

                    const resp = await this.$store.dispatch("auth/guardaRol", this.permisos);

                    if (resp.res=='OK') {
                        showSwal.methods.showSwal({
                            type: "success",
                            message: "Se ha actualizado el rol",
                            width: 600,
                        });
                        
                        this.$emit('cerrar-modal');
                    }
                    else {
                        showSwal.methods.showSwal({
                            type: "error",
                            message: resp.mensaje,
                            width: 500
                        });               
                    }
                } catch (error) {
                    this.loading = false;
                    showSwal.methods.showSwal({
                        type: "error",
                        message: "Se ha producido un error",
                        width: 500,
                    });
                }

      },
        cambiarDinamico(id) { console.log('id',id,this.permisos[id]);
            this.permisos[id] = this.permisos[id] == 0 ? 1 : 0;console.log('id2',id,this.permisos[id]);
        },
        validaMarcado(permiso_id) { 
            return this.permisos['permiso' + permiso_id];
        },
    },

    async mounted() {
        const permisos2 = await this.$store.dispatch("auth/permisos");

        const permisos = {};
        for (let i = 0; i < permisos2.length; i++) {
            permisos['permiso' + permisos2[i].id] = 0;
        }

        this.permisos2 = permisos2;
        this.permisos = permisos;

        for (let i = 0; i < this.rolEditPermisos.length; i++) { 
            if (permisos2[i].id==this.rolEditPermisos[i].permiso_id) {
                this.permisos['permiso' + permisos2[i].id] = 1;
            }
        } 
    }
  };
  </script>
  
  <style scoped>
  /* Estilos específicos del componente MyForm */
  </style>